import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { resolveSeo, SITE_NAME, SITE_ORIGIN } from './config';

export default function JsonLd() {
  const location = useLocation();

  useEffect(() => {
    document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());

    const seo = resolveSeo(location.pathname);
    const blocks: Record<string, unknown>[] = [];

    blocks.push({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: `${SITE_ORIGIN}/`,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_ORIGIN}/?search={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    });

    blocks.push({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: `${SITE_ORIGIN}/`,
      sameAs: ['https://kaspreadsheet.com'],
    });

    if (seo.kind === 'article' && seo.articleId) {
      const article = articles.find((a) => a.id === seo.articleId);
      if (article) {
        blocks.push({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: article.title,
          description: article.excerpt,
          image: article.image,
          datePublished: article.date,
          dateModified: article.date,
          author: { '@type': 'Organization', name: SITE_NAME },
          publisher: { '@type': 'Organization', name: SITE_NAME, url: `${SITE_ORIGIN}/` },
          mainEntityOfPage: `${SITE_ORIGIN}/article/${article.id}`,
        });
      }
    }

    blocks.forEach((block) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.text = JSON.stringify(block);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
    };
  }, [location.pathname]);

  return null;
}